'use client';

import { c as _c } from "react/compiler-runtime";
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import { useSession } from 'next-auth/react';
export const PostHogProvider = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const {
    data: session
  } = useSession();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (typeof window !== "undefined" && !!POSTHOG_KEY) {
        posthog.init(POSTHOG_KEY, {
          api_host: "https://us.i.posthog.com",
          session_recording: {
            maskAllInputs: false
          },
          autocapture: true
        });
      }
    };
    t2 = [POSTHOG_KEY];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] !== session) {
    t3 = () => {
      if (session?.user?.id) {
        posthog.identify(session.user.id, {
          email: session.user.email,
          name: session.user.name
        });
      }
    };
    t4 = [session];
    $[2] = session;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== children) {
    t5 = <PHProvider client={posthog}>{children}</PHProvider>;
    $[5] = children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};